// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sJtD","content":"styles_content__3-ZQ8","tableWrap":"styles_tableWrap__YASGQ"};